import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { Fragment } from 'react';
import { Flex } from '@finect/tabular-core/Flex';
import { Button } from '@finect/tabular-core/Button';
import { dataLayer } from '@finect/front-gtm';
import { getSuperPartnerBaseURL } from '@finect/front-utils/env';
import { getProfilePath } from '@finect/front-core/Profiles';
import { useTheme } from 'styled-components';
import { SceneLink } from '@finect/front-core/Routes';
import { Icon } from '../../Icon';
import { Inner, ContentBlock, AdviserTitle, AdviserOrganization, BadgesContent, CertificationBadge, InfoBlock } from './partials';
export var AdviserLine = function AdviserLine(_ref) {
  var adviser = _ref.adviser;
  var theme = useTheme();
  var certifications = adviser.certifications,
    icon = adviser.icon;
  var _adviser$organization = _slicedToArray(adviser.organizations, 1),
    organization = _adviser$organization[0];
  var organizationHasBlog = organization && organization.features && organization.features.blog;
  var adviserHasProfile = adviser.subtype === 'user' && adviser.features && adviser.features.includes('profile');
  var efpaCertification = certifications.find(function (item) {
    return item.organization === 'EFPA';
  });
  var aditionalIcon = efpaCertification ? {
    name: 'EFPA',
    url: "".concat(getSuperPartnerBaseURL(), "/image/").concat(efpaCertification.icon),
    icon: "".concat(getSuperPartnerBaseURL(), "/image/").concat(efpaCertification.icon)
  } : null;
  var path = getProfilePath(theme, adviser);
  var redirectToDM = function redirectToDM(evt) {
    evt.preventDefault();
    dataLayer({
      id: 'AdviserDM',
      type: 'click',
      params: {
        adviser: adviser
      },
      callback: function callback() {
        window.location = "".concat(getSuperPartnerBaseURL(), "/mensajes/nuevo?members=").concat(adviser.id);
      }
    });
  };
  return React.createElement(Inner, null, React.createElement(Flex, null, React.createElement("div", null, React.createElement(Icon, {
    alt: adviser.displayName,
    url: adviserHasProfile && path.url,
    image: icon ? "".concat(getSuperPartnerBaseURL(), "/image/").concat(icon) : null,
    type: "user",
    size: 4,
    aditionalIcon: aditionalIcon,
    withBorder: true,
    lazyLoad: true
  })), React.createElement(ContentBlock, null, adviserHasProfile ? React.createElement(SceneLink, {
    as: AdviserTitle,
    title: "Ver perfil del asesor financiero ".concat(adviser.displayName),
    scene: ['user'].includes(adviser.subtype) ? 'UserProfile' : 'GroupProfile',
    alias: adviser.alias,
    profile: adviser.alias
  }, adviser.displayName) : React.createElement(AdviserTitle, null, adviser.displayName), organization ? organizationHasBlog ? React.createElement(SceneLink, {
    as: AdviserOrganization,
    title: organization.displayName,
    scene: "GroupProfile",
    alias: organization.alias,
    profile: organization.alias
  }, organization.displayName) : React.createElement(AdviserOrganization, null, organization.displayName) : null, certifications.length ? React.createElement(BadgesContent, null, certifications.map(function (certification, index) {
    return React.createElement(CertificationBadge, {
      key: index
    }, "Cert. ", certification.title);
  })) : null)), React.createElement(InfoBlock, null, React.createElement(Flex, null, React.createElement(Fragment, null, "Conoce el producto y puede ayudarte con tus dudas."), React.createElement(Button, {
    width: "auto",
    variant: "small",
    onClick: function onClick(evt) {
      return redirectToDM(evt);
    }
  }, "Escribirle"))));
};
export default React.memo(AdviserLine);